module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("settings\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ff79e70"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/doctor/settings.vue
// module id = 820
// module chunks = 1